import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import Logo from "../assets/images/new-logo.png";

const Footer = () => (
  <Box mt="80px" bgcolor="#FFF3F4">
    <Stack
      gap="40px"
      sx={{ alignItems: "center" }}
      flexWrap="wrap"
      px="40px"
      pt="24px"
    >
      <img src={Logo} alt="logo" style={{ width: "400px", height: "100px" , borderRadius: "15px"}} />
    </Stack>
    <Typography
      variant="h5"
      sx={{ fontSize: { lg: "20px", xs: "20px" } }}
      mt="41px"
      textAlign="center"
      pb="40px"
    >
      Made with ❤️ by Utkarsh, IIT-BHU
    </Typography>
  </Box>
);

export default Footer;
